import { stackClasses, type Theme, typographyClasses } from '@mui/material';
import theme from 'providers/theme/theme';
import type { StyleExtend } from 'providers/theme/theme.types';

export const CoverageTableDesktopStyle: StyleExtend<Theme> = {
  border: `1px solid ${theme.palette.customColors.cream}`,
  borderTop: 'none',
  borderBottom: 'none',
  borderRadius: theme.spacing(0, 0, 0, 0),
  '.MuiDataGrid-columnHeader': {
    maxHeight: theme.spacing(5),
    px: 3,
    cursor: 'auto',
    ':focus': {
      outline: 'none',
    },
  },
  '.MuiDataGrid-cell': {
    borderBottom: `1px solid ${theme.palette.customColors.cream}`,
    borderTop: 'none !important',
    p: theme.spacing(2, 3),
    ':focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-row.Mui-selected,& .MuiDataGrid-row.Mui-selected:hover,& .MuiDataGrid-row:hover':
    {
      backgroundColor: 'unset',
    },

  '& .MuiDataGrid-columnHeader': {
    borderBottom: 'none !important',
  },

  '.MuiDataGrid-columnSeparator': {
    display: 'none',
  },

  '& .workers_compensation_message': {
    borderTop: 'none !important',
  },
};

export const CoverageTableDesktopFirstColumnStackStyle: StyleExtend<Theme> = {
  [`&>.${typographyClasses.root}: first-of - type`]: {
    fontWeight: 700,
  },

  [`& .${typographyClasses.root} `]: {
    textUnderlineOffset: theme.spacing(1),
  },

  [`&>.${stackClasses.root} `]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 1,

    [`.${typographyClasses.root} `]: {
      fontSize: 14,
      backgroundColor: theme.palette.customColors.lightBeige,
      borderRadius: theme.spacing(0.5),
      textDecorationThickness: theme.spacing(0.25),
      p: theme.spacing(0.5, 1, 1, 1),
    },
  },
};

export const CoverageTableDesktopNoWCCellStyle: StyleExtend<Theme> = {
  border: `1px solid ${theme.palette.customColors.cream}`,
  borderTop: 'none',
  borderBottom: 'none',
};

export const CoverageTableDesktopWCCellStyle: StyleExtend<Theme> = {
  '.MuiDataGrid-row:first-child .MuiDataGrid-cell': {
    border: 'none',
  },
};
